import SelectModeContext from '#/app/providers/SelectModeProvider/SelectModeContext';
import { useContext } from 'react';

export const useSelectMode = () => {
  const selectModeOn = useContext(SelectModeContext);

  return selectModeOn;
};

export default useSelectMode;
